<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="2"
                    :total="4" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-9",
            currentTrivia: 8,
            questions: {
                question: {
                    "title": "When should you reach out to API about potential ORC activity?",
                    "answers": [
                        {"key": "A", "answer": "The day after it’s observed"},
                        {"key": "B", "answer": "The week it’s observed"},
                        {"key": "C", "answer": "As soon as possible"},
                        {"key": "D", "answer": "Whenever you can"}
                    ],
                    "correctAnswer": ["C"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
